export default __webpack_public_path__ + "static/media/linkedin.4149dbe6.svg";